<div class="layout-container footer">
    <div class="row">
        <span class="logo" [innerHTML]="logoIcon.svgData | safeHtml"></span>
        <div class="title gilroy-bold">
            {{ 'FOOTER_V2.MISSION_TEXT' | translate }}
        </div>
    </div>

    <div class="row" [mediaClass]="['medium', 'center']">
        <div *mediaIf="'medium'">
            <app-badge class="feature hg"
            [touchRouterLink]="localeService.getLink(routesEnum.RELEASE_NOTES)"
            style="cursor: pointer">
            <app-icon class="font-24 margin-right" [icon]="starIcon"></app-icon>
            <span style="text-transform: uppercase">{{ 'FOOTER_V2.UPDATE_BADGE' | translate }}</span>
            </app-badge>
        </div>
        <div class="apps">
            <button [appButton]="loginIcon" class="frame light"
            [touchRouterLink]="localeService.getLink(routesEnum.SIGN_IN)"
            *mediaIf="'medium'">{{ 'FOOTER_V2.LOGIN' | translate }}</button>
            <a href="https://apps.apple.com/app/runple/id6742907148" target="_blank" touchHover rel="nofollow noopener">
                <img src="assets/images/home/app-store.svg" alt="Download on the App Store" />
                <img class="li" src="assets/images/home/app-store-light.svg" alt="Download on the App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.runple.mobile" touchHover target="_blank" rel="nofollow noopener">
                <img src="assets/images/home/play-store.svg" alt="Get it on Google Play" />
                <img class="li" src="assets/images/home/play-store-light.svg" alt="Get it on Google Play" />
            </a>
        </div>
    </div>

    <div class="row second">
        <div *mediaIf="'medium'">
            <button [appButton]="supportIcon" class="frame light margin-bottom-md"
            (touchClick)="openContactSupport()">{{ 'FOOTER_V2.CONTACT_SUPPORT' | translate }}</button>
            <p class="text-grey-60">{{ 'FOOTER_V2.SUPPORT_HOURS' | translate }}</p>
        </div>

        <div class="links" *mediaIf="'medium'">
            <div class="column">
                <p class="title">{{ 'FOOTER_V2.EXTENSIONS' | translate }}</p>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.INVENTORY_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.SERVICES)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.SERVICE_PROVIDERS' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.RETAIL)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.RETAIL' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.ECOMMERCE)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.ECOMMERCE' | translate }}</a>
            </div>
            <div class="column">
                <p class="title">{{ 'FOOTER_V2.FEATURES' | translate }}</p>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.ACCOUNTING)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.ACCOUNTING' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.SALES)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.SALES' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PRODUCTS)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.PRODUCT_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PARTNERS)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.BUSINESS_PARTNERS' | translate }}</a>
            </div>
            <div class="column">
                <p class="title" style="visibility: hidden" *mediaIf="'medium'">i</p>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.TEAM)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.HUMAN_RESOURCES' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.INVENTORY_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.TIME_TRACKING)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.TIME_TRACKING' | translate }}</a>
            </div>
        </div>

        <app-accordion-item [index]="0" [showBody]="true" *mediaIf="'small only'" [highlightStyle]="'dark'" [highlightInsetY]="-6" [highlightInsetX]="16" [icon]="angleDownIcon">
            <ng-container ngProjectAs="[accHeader]">
                <span class="feature-title">{{ 'FOOTER_V2.FEATURES' | translate }}</span>
            </ng-container>
            <div class="features-list">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.ACCOUNTING)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.ACCOUNTING' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.SALES)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.SALES' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PRODUCTS)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.PRODUCT_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PARTNERS)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.BUSINESS_PARTNERS' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.TEAM)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.HUMAN_RESOURCES' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.INVENTORY_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.TIME_TRACKING)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.TIME_TRACKING' | translate }}</a>
            </div>
        </app-accordion-item>

        <app-accordion-item [index]="1" *mediaIf="'small only'" [highlightStyle]="'dark'" [highlightInsetY]="-6" [highlightInsetX]="16" [icon]="angleDownIcon">
            <ng-container ngProjectAs="[accHeader]">
                <span class="feature-title">{{ 'FOOTER_V2.EXTENSIONS' | translate }}</span>
            </ng-container>
            <div class="features-list">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.INVENTORY_MANAGEMENT' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.SERVICES)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.SERVICE_PROVIDERS' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.RETAIL)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.RETAIL' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.ECOMMERCE)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.ECOMMERCE' | translate }}</a>
            </div>
        </app-accordion-item>
    </div>

    <div class="row third">
        <div>
            <button [appButton]="mailIcon" [mediaClass]="['small only', 'margin-bottom-md']" class="frame light"
            (touchClick)="openContactUs()">{{ 'FOOTER_V2.CONTACT_US' | translate }}</button>
        </div>
        <div class="links">
            <div class="column">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.ABOUT)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.ABOUT_RUNPLE' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PRICING)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.PRICING' | translate }}</a>
            </div>
            <div class="column">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.RELEASE_NOTES)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.RELEASE_NOTES' | translate }}</a>
                @if(app.currentLangIso === 'en') {
                    <a class="link" href="https://docs.runple.com/runple-handbook/" target="_blank">{{ 'FOOTER_V2.HANDBOOK' | translate }}</a>
                } @else {
                    <a class="link" href="https://docs.runple.com/runple-handbuch/" target="_blank">{{ 'FOOTER_V2.HANDBOOK' | translate }}</a>
                }
            </div>
            <div class="column">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.LEXICON)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.LEXICON' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.BLOG)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.BLOG' | translate }}</a>
            </div>
        </div>
    </div>

    <div class="row fouth">
        <div *mediaIf="'medium'"></div>
        <div class="links">
            <div class="column content-row text-grey-80">
                <a href="https://www.facebook.com/runple.gmbh" class="ex-href" touchHover target="_blank" rel="nofollow noopener" aria-label="Runple on Facebook">
                    <app-icon [icon]="fbIcon" aria-hidden="true"></app-icon>
                </a>
                <a href="https://twitter.com/runple_gmbh" class="ex-href" touchHover target="_blank" rel="nofollow noopener" aria-label="Runple on X">
                    <app-icon [icon]="xIcon" aria-hidden="true"></app-icon>
                </a>
                <a href="https://www.instagram.com/runple.gmbh" class="ex-href" touchHover target="_blank" rel="nofollow noopener" aria-label="Runple on Instagram">
                    <app-icon [icon]="instagramIcon" aria-hidden="true"></app-icon>
                </a>
                <a href="https://www.linkedin.com/company/runple" class="ex-href" touchHover target="_blank" rel="nofollow noopener" aria-label="Runple on LinkedIn">
                    <app-icon [icon]="linkedInIcon" aria-hidden="true"></app-icon>
                </a>
            </div>
            <div class="column content-row" *mediaIf="'medium'"></div>
            <div class="column content-row">
                <div class="text-grey-60">{{ 'FOOTER_V2.MADE_WITH' | translate:{ emoji: emoji } }}</div>
            </div>
        </div>
    </div>

    <div class="row fifth">
        <div>
            <!-- <app-select-input class="frame light icons-light full-width margin-bottom-md"
            [formControl]="regionControl" [theme]="'l'" [items]="regionItems" [disableSearch]="true">
            </app-select-input> -->
            
            <app-select-input class="frame light icons-light full-width"
                [showSelected]="{icon: langIcon, value: languageControl.value.name}"
                [formControl]="languageControl" [theme]="'l'" 
                [items]="languageItems" [disableSearch]="true">
            </app-select-input>
        </div>
        <div class="column">
            <div class="terms">
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.LEGAL)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.LEGAL_NOTICE' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.TERMS_OF_SERVICE)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.TERMS_OF_SERVICE' | translate }}</a>
                <a class="link" [touchRouterLink]="localeService.getLink(routesEnum.PRIVACY_POLICY)" [routerLinkActive]="'active'">{{ 'FOOTER_V2.PRIVACY_POLICY' | translate }}</a>
                <a class="link" (click)="openCookieSettings()" class="cursor-pointer">{{ 'FOOTER_V2.COOKIE_SETTINGS' | translate }}</a>
            </div>
            <div class="caption text-grey-60">{{ 'FOOTER_V2.COPYRIGHT' | translate }}</div>
            <div class="caption sm text-grey-60">{{ 'FOOTER_V2.TRADEMARK_NOTICE' | translate }}</div>
            <div class="caption text-grey-60">{{ 'FOOTER_V2.SOFTWARE_DESCRIPTION' | translate }}</div>
            <div class="caption icons sm text-grey-60">
                <p>
                    <app-icon [icon]="certIcon"></app-icon>
                    {{ 'FOOTER_V2.GDPR_COMPLIANT' | translate }}
                </p>
                <p>
                    <app-icon [icon]="serverIcon"></app-icon>
                    {{ 'FOOTER_V2.ISO_CERTIFIED' | translate }}
                </p>
                <p>
                    <app-icon [icon]="shieldIcon"></app-icon>
                    {{ 'FOOTER_V2.HOSTED_IN_GERMANY' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
